<template>
  <div class="min-h-screen bg-black flex items-center justify-center p-4">
    <div class="w-full max-w-md">
      <!-- Logo/Title -->
      <div class="text-center mb-8">
        <h1 class="text-4xl font-maax font-bold text-white mb-2">83 Islands</h1>
        <p class="text-gold text-lg">Admin Portal</p>
      </div>

      <!-- Login Card -->
      <div class="bg-white rounded-lg shadow-xl p-8">
        <h2 class="text-2xl font-maax font-bold text-gray-900 mb-6">Sign In</h2>

        <!-- Error Message -->
        <div v-if="error" class="mb-4 p-4 bg-red-50 border border-red-200 rounded-lg">
          <p class="text-sm text-red-800">{{ error }}</p>
        </div>

        <!-- Login Form -->
        <form @submit.prevent="handleLogin">
          <div class="mb-6">
            <label for="password" class="block text-sm font-medium text-gray-700 mb-2">
              Password
            </label>
            <input
              id="password"
              v-model="password"
              type="password"
              required
              class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gold focus:border-transparent outline-none transition-all"
              placeholder="Enter admin password"
              :disabled="loading"
            />
          </div>

          <button
            type="submit"
            :disabled="loading || !password"
            class="w-full bg-black text-white font-maax font-bold py-3 px-4 rounded-lg hover:bg-gray-800 transition-all disabled:opacity-50 disabled:cursor-not-allowed uppercase"
          >
            <span v-if="loading">Signing in...</span>
            <span v-else>Sign In</span>
          </button>
        </form>

        <!-- Help Text -->
        <div class="mt-6 text-center">
          <p class="text-sm text-gray-500">
            Enter the shared admin password to access the dashboard
          </p>
        </div>
      </div>

      <!-- Back to Site Link -->
      <div class="mt-6 text-center">
        <router-link
          to="/"
          class="text-gold hover:text-white transition-colors text-sm"
        >
          ← Back to website
        </router-link>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useAuth } from '../../composables/useAuth'

const router = useRouter()
const { login, loading, error } = useAuth()
const password = ref('')

const handleLogin = async () => {
  const result = await login(password.value)

  if (result.success) {
    // Redirect to admin dashboard
    router.push('/admin/dashboard')
  }
}
</script>

<style scoped>
.text-gold {
  color: #F6D993;
}

input:focus {
  box-shadow: 0 0 0 3px rgba(246, 217, 147, 0.1);
}
</style>
